import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  orderGroups: [],
  orderCount: 0,
});

export const loadOrders = createAction('LOAD_SIGNAGE_ORDERS');
export const loadOrdersSucceeded = createAction('LOAD_SIGNAGE_ORDERS_SUCCEEDED');
export const loadOrdersFailed = createAction('LOAD_SIGNAGE_ORDERS_FAILED');

function groupBy(list, props) {
  return list.reduce((a, b) => {
    const result = a;
    (result[b[props]] = result[b[props]] || []).push(b);
    return result;
  }, {});
}

const reducers = createReducer({
  [loadOrdersSucceeded]: (state, { signage }) => {
    const { states, orders } = signage;

    const groupedOrders = groupBy(orders, 'stateId');
    const groups = groupBy(states, 'groupName');

    let orderCount = 0;

    const orderGroups = Object.keys(groups).map(name => {
      const orders = groups[name].reduce((a, b) => a.concat(groupedOrders[b.id]), []).filter(a => !!a);
      orderCount = orderCount + orders.length;

      return {
        name,
        sortOrder: groups.sortOrder,
        orders,
      }
    }).sort((a, b) => a.sortOrder - b.sortOrder);

    return state.merge({ orderGroups, orderCount });
  }
}, INITIAL_STATE);

export default reducers;
